import React from "react";

import styled, { css } from "styled-components";

const Propierties = styled.div(
  ({ theme }) => css`
    ${theme.textTypes["Body-2-w400"]}
    color: #838aa2;
    line-height: 1.25;
    text-align: center;
    margin-top: ${(props) => (props.noMtop ? '0px' : '22px')};
    padding-bottom: 6px;
    width: 100%;
    word-wrap: break-word;
    white-space: pre-wrap;
    white-space: -moz-pre-wrap;
    white-space: -o-pre-wrap;
    @media (min-width: 951px) {      
      line-height: 1.43;
      text-align: center;
    }
  `
);

const InformationAmountCardText = ({ children, noMtop }) => {
  return <Propierties noMtop={noMtop}>{children}</Propierties>;
};

export default InformationAmountCardText;
